import React from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Avatar,
  Alert,
} from '@mui/material';
import { Error, Refresh, Home, ContactSupport } from '@mui/icons-material';

const PaymentFailure: React.FC = () => {
  const handleRetry = () => {
    window.location.href = '/payment';
  };

  const handleReturnHome = () => {
    window.location.href = '/';
  };

  const handleContactSupport = () => {
    // In a real app, this would open a support chat or redirect to support page
    window.open('mailto:support@masafinance.com?subject=Payment Issue', '_blank');
  };

  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <Avatar
        sx={{
          bgcolor: 'error.main',
          width: 80,
          height: 80,
          mx: 'auto',
          mb: 3,
        }}
      >
        <Error sx={{ fontSize: 50 }} />
      </Avatar>

      <Typography variant="h4" color="error.main" gutterBottom>
        Payment Failed
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        We're sorry, but your payment could not be processed at this time.
      </Typography>

      <Card variant="outlined" sx={{ maxWidth: 500, mx: 'auto', mb: 4 }}>
        <CardContent>
          <Alert severity="error" sx={{ mb: 3 }}>
            <Typography variant="body2">
              <strong>Payment Declined:</strong> Your transaction was not successful. 
              This could be due to insufficient funds, an expired card, or a security restriction.
            </Typography>
          </Alert>

          <Typography variant="h6" gutterBottom>
            What you can do:
          </Typography>
          
          <Box component="ul" sx={{ textAlign: 'left', pl: 2, mb: 0 }}>
            <Typography component="li" variant="body2" sx={{ mb: 1 }}>
              Check your payment details and try again
            </Typography>
            <Typography component="li" variant="body2" sx={{ mb: 1 }}>
              Ensure your card has sufficient funds
            </Typography>
            <Typography component="li" variant="body2" sx={{ mb: 1 }}>
              Try using a different payment method
            </Typography>
            <Typography component="li" variant="body2" sx={{ mb: 1 }}>
              Contact your bank if the issue persists
            </Typography>
            <Typography component="li" variant="body2">
              Reach out to our support team for assistance
            </Typography>
          </Box>
        </CardContent>
      </Card>

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', mb: 4 }}>
        <Button
          variant="contained"
          startIcon={<Refresh />}
          onClick={handleRetry}
          color="primary"
        >
          Try Again
        </Button>
        
        <Button
          variant="outlined"
          startIcon={<ContactSupport />}
          onClick={handleContactSupport}
        >
          Contact Support
        </Button>
        
        <Button
          variant="text"
          startIcon={<Home />}
          onClick={handleReturnHome}
        >
          Return to Home
        </Button>
      </Box>

      <Typography variant="body2" color="text.secondary">
        Error Code: PAY_001 • Transaction ID: TXN_FAILED_{Date.now()}
      </Typography>
    </Box>
  );
};

export default PaymentFailure; 